import { render, staticRenderFns } from "./BlockParagraphs.vue?vue&type=template&id=654272c7"
import script from "./BlockParagraphs.vue?vue&type=script&lang=js"
export * from "./BlockParagraphs.vue?vue&type=script&lang=js"
import style0 from "./BlockParagraphs.vue?vue&type=style&index=0&id=654272c7&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports